module.exports = __webpack_public_path__ + "images/pole.0ffa61f000dd5a3301adf434b46efce0.png";